import React from 'react';
export function FAQSection() {
  return <section className="py-16 bg-gray-100" data-id="element-133">
      <div className="container mx-auto px-4" data-id="element-134">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-135">
          ADDRESSING YOUR CONCERNS
        </h2>
        <div className="max-w-4xl mx-auto" data-id="element-136">
          <div className="mb-10" data-id="element-137">
            <h3 className="text-xl font-bold mb-4" data-id="element-138">
              "But I've Tried Natural Supplements Before..."
            </h3>
            <p className="mb-4" data-id="element-139">I get it. You've been burned before.</p>
            <p className="mb-4" data-id="element-140">
              You've wasted money on testosterone boosters that promised the
              world and delivered nothing but expensive urine.
            </p>
            <p className="mb-4" data-id="element-141">Here's why 247Alpha is different:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-142">
              <li data-id="element-143">
                <span className="font-bold" data-id="element-144">
                  Most supplements use cheap, synthetic versions
                </span>{' '}
                of natural compounds. We use only wild-harvested, standardized
                extracts from their native regions.
              </li>
              <li data-id="element-145">
                <span className="font-bold" data-id="element-146">Most use "proprietary blends"</span>{' '}
                to hide tiny, ineffective doses. We list every ingredient and
                dosage – and use clinically proven amounts.
              </li>
              <li data-id="element-147">
                <span className="font-bold" data-id="element-148">
                  Most are made in generic facilities
                </span>{' '}
                with poor quality control. 247Alpha is manufactured in an
                FDA-approved facility with pharmaceutical-grade standards.
              </li>
            </ul>
          </div>
          <div className="mb-10" data-id="element-149">
            <h3 className="text-xl font-bold mb-4" data-id="element-150">
              "Will This Make Me Dependent Like TRT?"
            </h3>
            <p className="mb-4" data-id="element-151">Absolutely not.</p>
            <p className="mb-4" data-id="element-152">
              TRT shuts down your natural testosterone production by flooding
              your system with synthetic hormones. Your testes literally shrink
              and stop working.
            </p>
            <p className="mb-4" data-id="element-153">
              247Alpha does the opposite – it supports and optimizes your body's
              natural hormone production.
            </p>
            <p className="mb-4" data-id="element-154">
              Think of it like going to the gym. Exercise doesn't make your
              muscles dependent – it makes them stronger and more capable.
            </p>
            <p className="mb-4" data-id="element-155">
              That's exactly what 247Alpha does for your endocrine system.
            </p>
          </div>
          <div className="mb-10" data-id="element-156">
            <h3 className="text-xl font-bold mb-4" data-id="element-157">
              "Is It Safe? Any Side Effects?"
            </h3>
            <p className="mb-4" data-id="element-158">
              247Alpha contains only natural ingredients that have been used
              safely for centuries.
            </p>
            <p className="mb-4" data-id="element-159">Unlike synthetic hormones, which can cause:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4 text-red-600" data-id="element-160">
              <li data-id="element-161">Testicle shrinkage</li>
              <li data-id="element-162">Hair loss</li>
              <li data-id="element-163">Liver damage</li>
              <li data-id="element-164">Blood clots</li>
              <li data-id="element-165">Mood swings</li>
            </ul>
            <p className="mb-4" data-id="element-166">
              247Alpha's natural ingredients work gently with your body's
              existing systems.
            </p>
            <p className="mb-4" data-id="element-167">The only "side effects" reported are:</p>
            <ul className="list-disc pl-6 space-y-2 text-green-600" data-id="element-168">
              <li data-id="element-169">Better sleep</li>
              <li data-id="element-170">Increased energy</li>
              <li data-id="element-171">Improved mood</li>
              <li data-id="element-172">Enhanced libido</li>
              <li data-id="element-173">Stronger erections</li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}